import React, {ReactNode} from 'react'
import {CondominiumGroupData} from '../condominiumGroup/repository/NatGetCondominiumGroup';

interface Props {
    condominiumGroup: CondominiumGroupData
    children?: ReactNode
}

interface CondominiumGroup {
    label: string,
    value: number | string
}

export default class NatCondominiumGroupDataListComponent extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    render(): React.ReactElement {
        const condominiumGroupList: { [key: number]: CondominiumGroup[] } = [];
        const level2CondominiumGroupInfo: CondominiumGroup[] = [];
        const level3CondominiumGroupInfo: CondominiumGroup[] = [];
        const level4CondominiumGroupInfo: CondominiumGroup[] = [];
        let key: number = 0;

        condominiumGroupList[key] = [
            {
                label: this.props.condominiumGroup.level1CondominiumGroupName,
                value: this.props.condominiumGroup.level1CondominiumGroupId,
            },
        ];

        if (this.props.condominiumGroup.level2CondominiumGroupInfo &&
            this.props.condominiumGroup.level2CondominiumGroupInfo.length !== 0) {
            key = 1;
            this.props.condominiumGroup.level2CondominiumGroupInfo.forEach((level2Info) => {
                if (level2Info.level2CondominiumGroupId && level2Info.level2CondominiumGroupName) {
                    level2CondominiumGroupInfo.push({
                        label: level2Info.level2CondominiumGroupName,
                        value: level2Info.level2CondominiumGroupId,
                    });
                }
                condominiumGroupList[key] = level2CondominiumGroupInfo

                if (level2Info.level3CondominiumGroupInfo &&
                    level2Info.level3CondominiumGroupInfo.length !== 0) {
                    key = 2;
                    level2Info.level3CondominiumGroupInfo.forEach((level3Info) => {
                        if (level3Info.level3CondominiumGroupId && level3Info.level3CondominiumGroupName) {
                            level3CondominiumGroupInfo.push({
                                label: level3Info.level3CondominiumGroupName,
                                value: level3Info.level3CondominiumGroupId,
                            })

                        }
                        condominiumGroupList[key] = level3CondominiumGroupInfo

                        if (level3Info.level4CondominiumGroupInfo &&
                            level3Info.level4CondominiumGroupInfo.length !== 0) {
                            key = 3;
                            level3Info.level4CondominiumGroupInfo.forEach((level4Info) => {
                                if (level4Info.level4CondominiumGroupId && level4Info.level4CondominiumGroupName) {
                                    level4CondominiumGroupInfo.push({
                                        label: level4Info.level4CondominiumGroupName,
                                        value: level4Info.level4CondominiumGroupId,
                                    })
                                }
                                condominiumGroupList[key] = level4CondominiumGroupInfo
                            })
                        }
                    })
                }
            })
        }

        return (
            <>{
                condominiumGroupList[key] &&
                condominiumGroupList[key].map((group, index) => (
                    <option key={index}
                            value={group.value}
                    >
                        {group.label}</option>
                ))
            }
            </>
        )
    }
}

